import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=ecf5080a&scoped=true&"
import script from "./ColorInput.vue?vue&type=script&lang=ts&"
export * from "./ColorInput.vue?vue&type=script&lang=ts&"
import style0 from "./ColorInput.vue?vue&type=style&index=0&id=ecf5080a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf5080a",
  null
  
)

export default component.exports